import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';

const ToggleSwitch = styled.input.attrs({ type: 'checkbox' })`
  height: 0;
  width: 0;
  visibility: hidden;

  & + & {
    cursor: pointer;
    text-indent: -9999px;
    width: 200px;
    height: 100px;
    background: grey;
    display: block;
    border-radius: 100px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 5px;
      left: 5px;
      width: 90px;
      height: 90px;
      background: #fff;
      border-radius: 90px;
      transition: 0.3s;
    }

    &:checked {
      background: var(--fi-accent, #ff6a00);

      &:after {
        left: calc(100% - 5px);
        transform: translateX(-100%);
      }
    }
  }
`;

const LabelForCheckBox = styled.label<{ theme?: any }>`
  cursor: pointer;
  text-indent: -9999px;
  width: 46px;
  height: 24px;
  background: ${({ theme }) => theme?.stroke || 'var(--fi-stroke, #d1d1d6)'};
  display: block;
  border-radius: 100px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    right: 0;
    width: 20px;
    height: 20px;
    background: ${({ theme }) => theme?.background1 || 'var(--fi-bg1, #fff)'};
    border-radius: 90px;
    transition: 0.3s;
  }

  ${ToggleSwitch}:checked + & {
    background: ${({ theme }) => theme?.primary || 'var(--fi-accent, #ff6a00)'};

    &::after {
      left: calc(100% - 2px);
      transform: translateX(-100%);
    }
  }
`;

const ToggleContainer = styled.div<{ theme?: any }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  margin-bottom: 20px;
  border: 1px solid
    ${({ theme }) => theme?.stroke || 'var(--fi-stroke, #d7d9d6)'};
  border-radius: 8px;
  background-color: ${({ theme }) =>
    theme?.background1 || 'var(--fi-bg1, #fff)'};
  min-height: 40px;
`;

const ToggleLabel = styled.div<{ theme?: any }>`
  font-size: 14px;
  font-family: Manrope;
  font-weight: 500;
  color: ${({ theme }) => theme?.text || 'var(--fi-text, #222428)'};
  line-height: 1;
`;

interface Props {
  label: string;
  value: boolean;
  onChange: (newValue: any) => void;
}

const CustomToggleSwitch: React.FC<Props> = ({ label, onChange, value }) => {
  const theme = useTheme();

  return (
    <ToggleContainer theme={theme.custom}>
      <ToggleLabel theme={theme.custom}>{label}</ToggleLabel>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ToggleSwitch checked={value} onChange={() => {}} />
        <LabelForCheckBox
          theme={theme.custom}
          onClick={() => onChange(!value)}
          htmlFor="switch"
        >
          Toggle
        </LabelForCheckBox>
      </div>
    </ToggleContainer>
  );
};

export default CustomToggleSwitch;
